/* eslint-disable @typescript-eslint/no-explicit-any */
import { ErrorHandler, Injectable } from '@angular/core';
import { InsightService } from '@app/services/insight.service';

@Injectable()
export class RumErrorHandler implements ErrorHandler {

    constructor(private readonly insightService: InsightService) {}

    handleError(error: any) {
        console.error('An error occurred:', error.message, error.stack);
        this.insightService.recordError(error);
    }
}